import { ConditionDesigner } from "../../editors/ConditionDesigner";
import type { negationConditionBuilder } from "./negationConditionBuilder";

export const NegationConditionSummary: typeof negationConditionBuilder.views.summary = ({ children: { values } }) => (
  <div>
    {values.length && (
      <>
        <p>Negate</p>
        <ConditionDesigner condition={values[0]} view="summary" />
      </>
    )}
  </div>
);
